import React from 'react';
import FilterList from '../../../components/user/variety/varietyFilterList';
import Layout from '../../../components/layouts/verticalLayout';

const VarietyListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

VarietyListPage.propTypes = {};

export default VarietyListPage;
